import React from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { Form } from "@carrotfertility/carotene-core-x"
import { useCurrentUser } from "#/components/context/user/UserContext"
import useAboutYou from "#/components/carrot-plans/hooks/useAboutYou"
import { carrotClient } from "#/utils/CarrotClient"
import { StepLayout } from "#/components/carrot-plans/shared/StepLayout"
import { ButtonFooterLayout, ContinueButton } from "#/components/carrot-plans/shared/ButtonFooter"
import { FormattedMessage, useIntl } from "react-intl"
import { Box } from "@carrotfertility/carotene-core"
import { RoutingFlowTitle } from "#/components/carrot-plans/shared"
import { useTrackExperimentEvent } from "../../../views/register/hooks/useExperiments"

export default function AboutYouIntro(): JSX.Element {
  const intl = useIntl()
  const aboutYouQuery = useAboutYou()
  const userInfo = useCurrentUser()

  const getSend = () => {
    return aboutYouQuery.data?.dateOfBirth && userInfo?.carrotPlansRoutingStarted ? "" : null
  }

  const { send } = useStateMachine(getSend())
  const { trackExperimentEvent } = useTrackExperimentEvent()

  async function onClickContinue(): Promise<void> {
    if (userInfo?.carrotPlansRoutingStarted === null) {
      try {
        await carrotClient.startCarrotPlansEnrollment()
        userInfo.refreshUserInfo()
      } catch (error) {
        reportError(error)
      }
    }
    send("")
  }

  // WQ-1587: Tracking for "show-registration-to-routing-cta" flag in Launch Darkly
  trackExperimentEvent("first-page-of-routing-visited")

  return (
    <>
      <RoutingFlowTitle
        title={intl.formatMessage({
          defaultMessage: "Tell us about your journey"
        })}
      />
      <Box display="flex" justifyContent="center" marginBottom={(theme) => theme.spacing(theme.tokens.spacing.lg)}>
        <Box
          component="img"
          src={`/images/illo-underwater-checklist.png`}
          srcSet={`/images/illo-underwater-checklist-2x.png`}
          alt=""
          marginBottom={(theme) => theme.spacing(theme.tokens.spacing.md)}
          height={228}
          width={228}
        />
      </Box>
      <StepLayout
        header={<FormattedMessage defaultMessage="Tell us more" />}
        slotProps={{
          header: {
            variant: "h4"
          }
        }}
        description={intl.formatMessage({
          defaultMessage:
            "So that we can create your Carrot Plan, please tell us more about yourself, where you are in your journey, and how we can help right now."
        })}
        formElements={
          <Form onSubmit={onClickContinue}>
            <ButtonFooterLayout
              continueButton={
                <ContinueButton>
                  <FormattedMessage defaultMessage="Continue" />
                </ContinueButton>
              }
            />
          </Form>
        }
      />
    </>
  )
}
